import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-home-proxy',
    template: `<ng-container *ngIf="showSme"><app-home-sme></app-home-sme></ng-container>
    <ng-container *ngIf="!showSme"><app-home-enus></app-home-enus></ng-container>`,
    standalone: false
})
export class HomeProxyComponent implements OnDestroy {
    showSme = false;

    private destroyed$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute
    ) {
        const showSmeparam = this.route.snapshot.queryParams['showSme'];
        if (showSmeparam === 'true') {
            this.showSme = true;
        }

    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
